exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#addAttachmentsModal[data-v-26844329] {\n    z-index: 9999;\n}\n#addAttachmentsModal .modal-content[data-v-26844329] {\n    min-height: 500px;\n}\n.border-none-top th[data-v-26844329] {\n    border-top: none;\n}\n.table-container[data-v-26844329] {\n    height: 75vh;\n    overflow: auto;\n}\n.table-font-size[data-v-26844329] {\n    font-size: .85rem;\n}\n.sections[data-v-26844329] {\n    width: 200px;\n}      \n", ""]);

// exports
